import React from "react";
import { Info } from "lucide-react";

import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { eintrag, istSeite } from "@/hilfe/register";

// Schicht 1 (Auftrag 8, R1): ein ⓘ neben dem Begriff, der Text aus dem
// Register. EINE Komponente nach außen -- innen zwei Wege zum selben Text:
//   Maus darüber  -> Tooltip (Radix)
//   Tippen/Klick  -> Popover, mit „mehr", falls der Eintrag es hat
// Gemessen am 03.11.2026 (Auftrag 8, A6): Der Radix-Tooltip öffnet auf
// Berührung absichtlich nicht -- ein Tippen sieht er als Klick, und ein Klick
// schließt ihn. Ohne den Popover bliebe die Hilfe auf dem Tablet stumm.

export const Hilfe = ({ id }) => {
    if (istSeite(id)) throw new Error(`<Hilfe id="${id}">: Seitenköpfe gehören in <Seitenkopf>`);
    const e = eintrag(id);
    if (!e) return null;
    return (
        <TooltipProvider delayDuration={200}>
            <Popover>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <PopoverTrigger asChild>
                            <button type="button" aria-label="Erklärung" data-testid={`hilfe-${id}`}
                                    className="inline-flex align-middle text-gray-400 hover:text-slate-700 ml-1">
                                <Info size={13} />
                            </button>
                        </PopoverTrigger>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-xs font-normal" data-testid={`hilfe-text-${id}`}>
                        {e.text}
                    </TooltipContent>
                </Tooltip>
                <PopoverContent className="max-w-xs text-sm font-normal text-slate-700 space-y-2"
                                data-testid={`hilfe-popover-${id}`}>
                    <p>{e.text}</p>
                    {e.mehr && <p className="text-xs text-gray-500">{e.mehr}</p>}
                </PopoverContent>
            </Popover>
        </TooltipProvider>
    );
};
